export default "__VITE_ASSET__CCW1nuHd__"